"use strict";
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
Object.defineProperty(exports, "__esModule", { value: true });
exports.convertBase64UrlToArrayBuffer = exports.convertArrayBufferToBase64Url = void 0;
var base64url_1 = require("./base64url");
Object.defineProperty(exports, "convertArrayBufferToBase64Url", { enumerable: true, get: function () { return base64url_1.convertArrayBufferToBase64Url; } });
Object.defineProperty(exports, "convertBase64UrlToArrayBuffer", { enumerable: true, get: function () { return base64url_1.convertBase64UrlToArrayBuffer; } });
